module.exports = __webpack_public_path__ + "media/en_gb_s2_Keeton.c00543f3.oga";